export const flatItems = (items: any[]) => {
  return items.map(({ item, ...rest }) => {
    return { ...rest, ...item, id: rest.id };
  });
};
